import React from 'react'

import Image from '@src/models/Image'

type ImageType = 'largeHero' | 'hero' | 'portraitHero' | 'thumbnail'

// 参考: https://document.microcms.io/image-api/introduction
export type MicrocmsImageProps = {
  image: Image
  alt: string
  type: ImageType
  disableLazyLoad?: boolean
  disableAspectRatio?: boolean
}

const MicrocmsImage: React.FC<MicrocmsImageProps> = ({
  image,
  alt,
  type,
  disableLazyLoad = false,
  disableAspectRatio = false,
}) => {
  const { pcUrl, spUrl } = formatUrl(image.url, type)
  const aspectRatio =
    disableAspectRatio ||
    image.height === undefined ||
    image.width === undefined ||
    image.height === 0 ||
    image.width === 0
      ? undefined
      : image.width / image.height

  return (
    <picture>
      <source
        media="(max-width: 600px)"
        srcSet={`${spUrl} 1x, ${spUrl}&dpr=2 2x`}
      />
      <source srcSet={`${pcUrl} 1x, ${pcUrl}&dpr=2 2x`} />
      <img
        src={pcUrl}
        alt={alt}
        loading={disableLazyLoad ? 'eager' : 'lazy'}
        style={{ aspectRatio }}
      />
    </picture>
  )
}

const formatUrl = (imageUrl: string, type: ImageType) => {
  const widthMap = {
    largeHero: {
      pc: 1500,
      sp: 420, // SPで420pxあればほとんどの端末をカバーできる
    },
    hero: {
      pc: 700,
      sp: 420,
    },
    portraitHero: {
      pc: 500,
      sp: 280, // CSSで横幅の60%で指定されているため
    },
    thumbnail: {
      pc: 400,
      sp: 200,
    },
  }
  // gifの場合webpにするとコマ数が落ちるのでサイズだけ変更する
  const fmParamString = /\.gif$/.test(imageUrl) ? '' : '&fm=webp'

  return {
    pcUrl: `${imageUrl}?w=${widthMap[type].pc}${fmParamString}`,
    spUrl: `${imageUrl}?w=${widthMap[type].sp}${fmParamString}`,
  }
}

export const formatOgpUrl = (imageUrl: string) =>
  `${imageUrl}?h=630&w=1200&fit=crop`

export default MicrocmsImage
